import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ResourceService } from 'src/app/global/services/resource.service';
import { WEB_API } from 'src/app/global/services/web-api';
import { AuditoriaConferenciaCaixaGeral } from '../domain/auditoria-conferencia-caixa-geral.model';
import { Produto } from '../domain/produto.model';
import { Page, ReturnAPI } from '../domain/return-api.model';
import { AuditoriaConferenciaCaixaGeralSerializer } from '../serializables/auditoria-conferencia-caixa-geral.serializer';

@Injectable()
export class AuditoriaConferenciaCaixaGeralService extends ResourceService<AuditoriaConferenciaCaixaGeral> {
  static RESOURCE = 'auditoria-conferencia-caixa-geral';
  produto: Produto;
  produtoId: string;

  constructor(private http: HttpClient) {
    super(
      http,
      `${WEB_API}`,
      `${AuditoriaConferenciaCaixaGeralService.RESOURCE}`,
      new AuditoriaConferenciaCaixaGeralSerializer(AuditoriaConferenciaCaixaGeral),
    );
  }

  findAll(queryOption: QueryOptions): Observable<ReturnAPI<Page<AuditoriaConferenciaCaixaGeral>>> {
    this.getProduto();
    return this.httpClient.get<ReturnAPI<Page<AuditoriaConferenciaCaixaGeral>>>(
      `${WEB_API}/${AuditoriaConferenciaCaixaGeralService.RESOURCE}?${queryOption.toQueryString()}&${this.produtoId}`,
    );
  }

  getProduto(): void {
    if (sessionStorage.getItem('produto')) {
      this.produto = JSON.parse(sessionStorage.getItem('produto'));
      this.produtoId = Number.isInteger(this.produto.id) ? 'produtoId=' + this.produto.id : '';
    }
  }
}
